export default {
    computed: {
        publicPath() {
            let publicPath = this.$router.options.base;
            if (publicPath === undefined || publicPath === null) {
                return '';
            }
            
            publicPath = publicPath.trim();
            if (publicPath === '' || publicPath === '/')
            {
                return '';
            }
            
            if (publicPath.slice(-1) === '/')
            {
                return publicPath.substring(0, publicPath.length - 1);
            }
            
            return publicPath;
        }
    }
}